import { css } from 'styled-components';

/**
 * @typedef {{xl: 1920,
 *            lg: 1280,
 *            mdLg: 1024,
 *            md: 960,
 *            tablet: 768,
 *            sm: 600,
 *            xs: 0}} MediaQuery
 */
export const breakpoints = {
  xl: '1920px',
  lg: '1280px',
  mdLg: '1024px',
  md: '960px',
  tablet: '768px',
  sm: '600px',
  xs: '320px',
};

const getBreakpointValue = label => {
  const breakpointValueStr = breakpoints[label].replace('px', '');
  return parseInt(breakpointValueStr, 10);
};

/**
 * @type {MediaQuery}
 */
export const smallerThanOrEqualTo = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label]}) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

/**
 * @type {MediaQuery}
 */
export const smallerThan = Object.keys(breakpoints).reduce((acc, label) => {
  const breakpointValue = getBreakpointValue(label);

  acc[label] = (...args) => css`
    @media (max-width: ${breakpointValue - 1}px) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

/**
 * @type {MediaQuery}
 */
export const biggerThanOrEqualTo = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

/**
 * @type {MediaQuery}
 */
export const biggerThan = Object.keys(breakpoints).reduce((acc, label) => {
  const breakpointValue = getBreakpointValue(label);

  acc[label] = (...args) => css`
    @media (min-width: ${breakpointValue + 1}px) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

/**
 * Target IE10+
 * @param {css} args
 * @returns {css}
 */
export const ie10Up = (...args) => css`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    ${css(...args)}
  }
`;

export const iphone5 = (...args) => css`
  @media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-device-pixel-ratio: 2) and (device-aspect-ratio: 40/71) and (orientation: portrait) {
    ${css(...args)}
  }
`;
